import {useState} from "react";
import CannedNotesForm from "./CannedNotesForm";

const CreateCannedNotes = () => {

    const [crumbs] = useState([
        {content: "Home", url: "/"},
        {content: "Canned Notes", url: "/canned-notes"},
        {content: "Add Canned Note", url: ""},
    ]);

    return (
        <>
            <CannedNotesForm crumbs={crumbs} title={"Add Canned Note"} btnText={"Create"}/>
        </>
    )
}
export default CreateCannedNotes;